import { isAxiosError } from 'axios'

// For 422 errors, returns the top-level message from the response
export function getErrorMessage(err: unknown, fallback: string): string {
  if (isAxiosError(err) && err.response?.status === 422) {
    const message = (err.response.data as { message?: string } | undefined)
      ?.message
    if (message) return message
  }

  return fallback
}
